// Enable/disable save button based on HTML5 validation rules
const updateSaveButton = (form, saveButton) => {
  saveButton.disabled = !form.checkValidity();
};

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('modal-holder');
  if (modal) {
    modal.addEventListener('shown.bs.modal', () => {
      const form = modal.querySelector(
        '[data-validate-form="selected-action-plan"]',
      );
      if (form) {
        const saveButton = form.querySelector('button[type="submit"]');
        // Re-check validity whenever a field value changes
        form.addEventListener('input', () => updateSaveButton(form, saveButton));
        form.addEventListener('change', () => updateSaveButton(form, saveButton));
        // Cocoon: re-check when a nested field is added
        $(form).on('cocoon:after-insert', () => updateSaveButton(form, saveButton));
        // Cocoon: re-check when a nested field is removed
        $(form).on('cocoon:after-remove', () => updateSaveButton(form, saveButton));
        // Set the initial button state when the form loads
        updateSaveButton(form, saveButton);
      }
    });
  }
});
